// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"v8-z"};